import { render, staticRenderFns } from "./tabla-productores.vue?vue&type=template&id=f77b9bf6&scoped=true&"
import script from "./tabla-productores.vue?vue&type=script&lang=js&"
export * from "./tabla-productores.vue?vue&type=script&lang=js&"
import style0 from "./tabla-productores.vue?vue&type=style&index=0&id=f77b9bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b9bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
